import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { AlertCircle, ArrowLeftCircle } from "lucide-react";

/**
 * Platform-wide banner that appears whenever the current session is an admin
 * impersonating another user. One-click return to the original admin.
 * Rendered by Layout at the very top so it can't be missed.
 */
export default function ImpersonationBanner() {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user?.impersonated_by) return null;

  const stop = async () => {
    setBusy(true);
    try {
      await api.post("/admin/impersonate-stop");
      const { data: me } = await api.get("/auth/me");
      setUser(me);
      toast.success("Returned to admin");
      window.location.href = "/counselor";
    } catch (e) { toast.error(formatApiError(e)); setBusy(false); }
  };

  return (
    <div className="sticky top-0 z-40 w-full text-sm"
         data-testid="impersonation-banner"
         style={{ background: "#E6B23A", color: "#1C211E" }}>
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between flex-wrap gap-2">
        <div className="inline-flex items-center gap-2">
          <AlertCircle className="w-4 h-4" />
          <span>
            You're viewing the app as <strong>{user.name}</strong> ({user.email}).
            Actions you take are performed as this user.
          </span>
        </div>
        <button onClick={stop} disabled={busy}
          data-testid="impersonation-stop"
          className="inline-flex items-center gap-1 rounded-full px-3 py-1 font-semibold"
          style={{ background: "#1C211E", color: "#fff" }}>
          <ArrowLeftCircle className="w-4 h-4" /> Return to admin
        </button>
      </div>
    </div>
  );
}
